import { Badge, IconBox, IgnoreIcon } from "@hightouch/htui";
import {
  DefinitionStatusBadge,
  DefinitionStatusIcon,
} from "src/pages/context-hub/definitions/definition-status";
import {
  CITATION_STATUS_LABELS,
  type CitationStatus,
} from "./resolved-citation";

export const CitationStatusIcon = ({ status }: { status: CitationStatus }) =>
  status === "deleted" ? (
    <IconBox
      color="gray"
      icon={
        <IgnoreIcon role="img" aria-label={CITATION_STATUS_LABELS.deleted} />
      }
    />
  ) : (
    <DefinitionStatusIcon status={status} />
  );

export const CitationStatusBadge = ({ status }: { status: CitationStatus }) =>
  status === "deleted" ? (
    <Badge variant="subtle" svgIcon={IgnoreIcon}>
      {CITATION_STATUS_LABELS.deleted}
    </Badge>
  ) : (
    <DefinitionStatusBadge status={status} />
  );
